import { useEffect, useState } from "react";
import { useTV } from "../../../hooks/useTV";
import { getVipSelectorBackground } from "../MultiView/multi-view.utils"; // ✅ NEW IMPORT
import VipSubCheck from "./VipSubCheck";
import useGlobalStore from "../../../store/global.store";

const VipSelector = () => {
  const { isTv } = useTV();
  const setShowBottomBar = useGlobalStore((state) => state.setShowBottomBar);
  const [backgroundImage, setBackgroundImage] = useState(() =>
    getVipSelectorBackground(isTv)
  ); // ✅ NEW STATE

  useEffect(() => {
    const interval = setInterval(() => {
      setBackgroundImage(getVipSelectorBackground(isTv));
    }, 60000);
    return () => clearInterval(interval);
  }, [isTv]); // ✅ NEW EFFECT

  useEffect(() => {
    setShowBottomBar(true);
  }, [isTv]);

  return (
    <div
      style={{
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 50,
      }}
    >
      <img
        src={backgroundImage} // ✅ REPLACED STATIC IMAGE WITH STATE
        alt="vip-door-selector"
        style={{
          position: "absolute",
          top: isTv ? "-50px" : "-50px",
          left: 0,
          width: "100%",
          height: "auto",
          zIndex: 1,
        }}
      />

      <VipSubCheck />
    </div>
  );
};

export default VipSelector;
